export default "__VITE_ASSET__Bb$QcKCK__"